import classNames from "classnames";
import React, { PropsWithChildren } from "react";
import { Icon, IconName } from "../icon";
import { TransparentButton } from "../transparent-button";
import { useTabsContext } from "./context";
import "./tab-button.css";

export function TabButton({
	children,
	iconName,
	value,
}: PropsWithChildren<{
	iconName: IconName;
	value: string;
}>) {
	const { activeTab, setActiveTab } = useTabsContext();

	const styles = classNames({
		"tab-button": true,
		"tab-button--active": activeTab === value,
	});

	return (
		<TransparentButton className={styles} onClick={() => setActiveTab(value)}>
			<div className="tab-button__icon">
				<Icon iconName={iconName} />
			</div>
			<div className="tab-button__label">{children}</div>
		</TransparentButton>
	);
}
